import { cn } from '@/lib/utils'
import { Slider as SliderPrimitive } from 'radix-ui'
import * as React from 'react'

function Slider({
  className,
  thumbAriaLabel,
  thumbAriaValueText,
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root> & {
  thumbAriaLabel?: string
  thumbAriaValueText?: string
}) {
  const initialValue = Array.isArray(props.value)
    ? props.value
    : [props.min, props.max]

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      className={cn(
        'relative flex w-full touch-none items-center select-none',
        className
      )}
      {...props}>
      <SliderPrimitive.Track className="bg-secondary relative h-2 w-full grow overflow-hidden rounded-full">
        <SliderPrimitive.Range className="bg-primary absolute h-full" />
      </SliderPrimitive.Track>
      {initialValue.map((_, index) => (
        <React.Fragment key={index}>
          <SliderPrimitive.Thumb
            aria-label={thumbAriaLabel}
            aria-valuetext={thumbAriaValueText}
            className="border-primary bg-background focus-visible:border-ring focus-visible:ring-ring/50 block h-4 w-4 rounded-full border-2 transition-[color,background-color,border-color,box-shadow,opacity] outline-none focus-visible:ring-[3px] disabled:pointer-events-none disabled:opacity-50"
          />
        </React.Fragment>
      ))}
    </SliderPrimitive.Root>
  )
}

export { Slider }
